module.exports = __webpack_public_path__ + "static/media/logo-6.3cb7d020.png";